import React, { SetStateAction, Dispatch } from 'react'
import { ActionIcon, Stack, Stepper, Text, Title, Grid, Box, ScrollArea } from "@mantine/core"
import { DefineStepDetails } from './DefineStepDetails'
import { StatusIcon } from './StatusIcon'
import { PricingVersion } from '../../GlobalJobMatchingVersioning/types/versions'
import { JobsStepDetails } from './JobsStepDetails'
import { DataCutStepDetails } from './DataCutStepDetails'
import { MethodologyStepDetails } from './MethodologyStepDetails'
import { getShortDate } from '../../../../lib/formatters'
import { IconLayoutSidebarRightCollapse } from '@tabler/icons-react'

type SideProgressProps = {
  onClose: () => void
  pricingVersion: PricingVersion | undefined
  stepIndex: number
  setStepIndex: Dispatch<SetStateAction<number>>
  style: React.CSSProperties
}

export const SideProgress = ({ pricingVersion, stepIndex, setStepIndex, style, onClose }: SideProgressProps) => {
  if (!pricingVersion) return
  const stepColors = ['lightBlue', 'darkOrange', 'lightOrange', 'purple', 'green']
  const getStepColor = (currentIndex: number, stepIndex: number) => {
    if (currentIndex >= stepIndex) return stepColors[stepIndex]
    return 'lightgray'
  }

  const fileRequired = pricingVersion?.matchStrategy === 'file' && !pricingVersion?.metadata?.filename

  const data = [
    { label: 'Status', value: <StatusIcon pricingVersion={pricingVersion} /> },
    { label: 'Needs to run', value: pricingVersion.requiresRun ? 'true' : 'false' },
    { label: 'Created by', value: pricingVersion.createdBy },
    { label: 'Created on', value: getShortDate(pricingVersion.created) },
    { label: 'Modified on', value: getShortDate(pricingVersion.lastModified) },
  ];

  return (
    <Box style={{...style}}>
      <ScrollArea style={{ height: '90%' }}>
        <Stack p='lg' miw={390}>
          <Grid mb='lg'>
            <Grid.Col span={10}>
              {data.map((item, index) => (
                <Grid key={index}>
                  <Grid.Col span={4}>
                    <Text>{item.label}</Text>
                  </Grid.Col>
                  <Grid.Col span={8}>
                    <Text c='black'>{item.value}</Text>
                  </Grid.Col>
                </Grid>
              ))}
            </Grid.Col>
            <Grid.Col span={2} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-start' }}>
              <ActionIcon
                onClick={onClose}
                variant="outline"
                color="black"
                style={{ borderRadius: 4, borderColor: '#d5e0ea', borderWidth: 2 }}
                size={50}
              >
                <IconLayoutSidebarRightCollapse size={20} />
              </ActionIcon>
            </Grid.Col>
          </Grid>

          <Title order={4} mb='lg'>WORKFLOW STAGES</Title>
          <Stepper color="lightgray" active={stepIndex + 1} onStepClick={(step) => setStepIndex(step)} orientation="vertical">
            <Stepper.Step color={getStepColor(stepIndex, 0)} description={<DefineStepDetails />}/>
            <Stepper.Step color={getStepColor(stepIndex, 1)} disabled={fileRequired} description={<JobsStepDetails />} />
            <Stepper.Step color={getStepColor(stepIndex, 2)} disabled={fileRequired} description={<DataCutStepDetails />} />
            <Stepper.Step color={getStepColor(stepIndex, 3)} disabled={fileRequired} description={<MethodologyStepDetails />} />
            <Stepper.Step color={getStepColor(stepIndex, 4)} disabled={fileRequired} description={<Title order={3} c='black'>Review</Title>} />
          </Stepper>
        </Stack>
      </ScrollArea>
    </Box>
  )
}
